__turbopack_context__.v({
  "buttonGroupContainer": "linkPanelButton-module-scss-module__Tz13TW__buttonGroupContainer",
  "panelButtonContainer": "linkPanelButton-module-scss-module__Tz13TW__panelButtonContainer",
  "panelLink": "linkPanelButton-module-scss-module__Tz13TW__panelLink",
});
